
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-port-demo-port-config","docs-tutorial-basic-port-demo-port-prop"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.zh.md?type=demo')
};